import { BaseError } from './errors/BaseError'

/*
 * Declare `msSaveBlob` type globally as newer versions of the TypeScript
 * compiler doesn't offer IE support anymore
 */
declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean
    }
}

export const downloadCSV = (csv: string, fileName: string): void => {
    if (!document)
        throw new BaseError({
            cause: new Error('client not ready'),
            message: 'Something went wrong',
        })
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })

    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName)
    } else {
        const link = document.createElement('a')
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', fileName)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}
